import React from "react";
import "./TermsAndConditions.css";

function TermsAndConditions() {
  return (
    <div className="tc-page">
      <div className="tc-shell">
        <div className="tc-header">
          <div className="tc-kicker">kazhavDa</div>
          <h2>Услови и одредби</h2>
          <p className="tc-updated">Последно ажурирано: Април 30, 2025</p>
        </div>

        <div className="tc-section">
          <h4>1. Прифаќање на условите</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Со пристап и користење на kazhavDa платформата (&quot;Услуга&quot;),
              која вклучува веб-страница и поврзани алатки за организирање и
              планирање свадба, Вие се согласувате со овие Услови и одредби
              („Договор“). Ако не се согласувате, морате веднаш да го прекинете
              користењето.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>2. Толкување и дефиниции</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>Дефинираните термини во овој Договор имаат следното значење:</p>
            <p>
              Сметка: Вашиот единствен кориснички профил за пристап до Услугата.
            </p>
            <p>
              Содржина: текст, слики или друг материјал што го објавувате или
              генерирате преку Услугата.
            </p>
            <p>
              Услуга: веб-страница и дигитални алатки за планирање свадба,
              вклучувајќи профили, гости, распоредување на маси, покани,
              фото-албуми и други организаторски функции.
            </p>
            <p>Веб-страница: https://kazhavda.mk.</p>
            <p>
              Вие, Корисник: физичко или правно лице кое пристапува и ја користи
              Услугата.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>3. Регистрација на сметка</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Мора да регистрирате Сметка за да ги користите одредени функции.
              Потврдувате дека сите податоци што ги давате при регистрацијата се
              точни и дека имате правен капацитет за склучување на овој Договор.
              Вие сте одговорни за чување на Вашите пристапни податоци и за сите
              активности поврзани со Вашата Сметка.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>4. Користење на Услугата</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              <strong>4.1 Дозволено користење</strong>
            </p>
            <p>
              Услугата можете да ја користите исклучиво за законски и лични цели
              поврзани со организирање и подготовка на вашата свадба, во
              согласност со овој Договор.
            </p>
            <p>
              <strong>4.2 Забранети постапки</strong>
            </p>
            <p>Се согласувате дека нема да:</p>
            <ul>
              <li>Ги кршите применливите закони и регулативи.</li>
              <li>Навредувате, малтретирате или наштетувате на други лица.</li>
              <li>Го попречувате или прекинувате функционирањето на Услугата.</li>
              <li>
                Обидувате се да остварите непрописен пристап до кој било дел од
                Услугата.
              </li>
              <li>Пренесувате штетен код, вируси или друг малвер.</li>
            </ul>
            <p>
              Откако ќе заврши пробниот период на претплатата, нема поврат или
              рефундирање на средства. При купување пакет-планови нема пробен
              период и нема поврат на средства.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>5. Интелектуална сопственост</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Сите права, титули и интереси во и за Услугата (вклучувајќи
              софтвер, текст, графики, логоа и дизајни) припаѓаат на Компанијата
              или нејзините лиценцодавци. Без нашето изрично овластување, не
              смеете да копирате, модифицирате, дистрибуирате или создавате
              деривативни дела.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>6. Содржина создадена од корисници</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Со објавување Содржина преку Услугата, ни давате светска, безпатна,
              соопштлива и пренослива лиценца за користење, размножување,
              дистрибуција, создавање деривативни дела, прикажување и изведување
              на таа Содржина во врска со функционирањето и обезбедувањето на
              Услугата.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>7. Линкови до трети страни</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Услугата може да вклучува линкови до веб-страници на трети страни
              кои не се во наша сопственост или контрола. Ние не сме одговорни за
              содржината, практиките за приватност или штетите што може да
              произлезат од користење на тие страници.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>8. Плаќање и такси</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Доколку купувате платени пакети или претплати, се согласувате да ги
              платите сите применливи такси. Плаќањата се обработуваат преку Lemon
              Squeezy. Откако ќе заврши пробниот период на претплатата, нема поврат
              или рефундирање на средства. При купување пакет-планови нема пробен
              период и нема поврат на средства.
            </p>
            <p>За повеќе детали, погледнете ги условите на Lemon Squeezy:</p>
            <ul>
              <li>
                <a
                  href="https://www.lemonsqueezy.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Lemon Squeezy Terms
                </a>
              </li>
              <li>
                <a
                  href="https://www.lemonsqueezy.com/buyer-terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Lemon Squeezy Buyer Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="tc-section">
          <h4>9. Одбивање на гаранции</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              УСЛУГАТА СЕ ОБЕЗБЕДУВА „КАКО ШТО Е“ И „КАКО ШТО Е ДОСТАПНА“ БЕЗ
              НИКАКВИ ГАРАНЦИИ, ИЗРИЧНИ ИЛИ ИМПЛИЦИТНИ, ВКЛУЧУВАЈЌИ ГАРАНЦИИ ЗА
              ПРОДАЖНОСТ, ПРИЛАГОДЕНОСТ ЗА ОДРЕДЕН ЦЕЛ ИЛИ НЕКРИШЕЊЕ.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>10. Ограничување на одговорноста</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              ВООПШТО ДО НАЈГОЛЕМИОТ ДОЗВОЛЕН ОД ЗАКОНОТ, kazhavDa НЕ Е ОДГОВОРЕН
              ЗА НИКАКВИ НЕПОСРЕДНИ, ПОСЛЕДИЧНИ, СПЕЦИЈАЛНИ, СЛУЧАЈНИ ИЛИ КАЗНЕНИ
              ШТЕТИ КОИ ПРОИЗЛЕГУВААТ ОД ВАШЕТО КОРИСТЕЊЕ НА УСЛУГАТА.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>11. Обврска за обесштетување</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Се согласувате да ја обесштетите и да ја заштитите kazhavDa и
              нејзините Филијали од сите барања, обврски, штети, загуби или
              трошоци што произлегуваат од вашето кршење на овој Договор или
              вашето користење на Услугата.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>12. Временска рамка и раскинување</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Овој Договор важи додека ја користите Услугата. Можеме да го
              суспендираме или раскинеме вашиот пристап во секое време доколку го
              прекршите овој Договор. По прекинувањето, вашите права за користење
              на Услугата престануваат веднаш.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>13. Применливо право и решавање спорови</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Овој Договор се регулира со законите на Северна Македонија, без
              оглед на колизиските норми. Сите спорови ќе се решаваат во
              надлежните судови во Скопје.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>14. Измени на Условите</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>
              Можеме да ги ажурираме овие Услови во секое време. Ќе ја објавиме
              ревидираната верзија на Услугата со нов датум „Последно ажурирано“.
              Вашето продолжено користење по измените се смета за прифаќање.
            </p>
          </div>
        </div>

        <div className="tc-section">
          <h4>15. Контакт информации</h4>
          <hr className="my-1" />
          <div className="tc-body">
            <p>За прашања во врска со овие Услови, контактирајте не на:</p>
            <p>Е-пошта: support@kazhavda.mk</p>
            <p>Веб-страница: kazhavda.mk</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
